import cls from "./AdminRoundControlPanel.module.scss";

export default function AdminRoundControlPanel({
  roundState,
  turnView,
  loading,
  onChangeRound,
  onOpenPenalty,
  onResolveDare,
}) {
  const currentRound = Number(roundState?.currentRound || 1);
  const suggested = Boolean(roundState?.roundAdvanceSuggested);
  const count = Number(roundState?.availableRoundQuestionCount || 0);
  const turnStatus =
    turnView?.turn?.status || roundState?.activeTurnStatus || "idle";

  return (
    <section className={cls.panel}>
      <div className={cls.statsRow}>
        <article className={cls.statCard}>
          <span>Current Round</span>
          <strong>{currentRound}</strong>
        </article>
        <article className={cls.statCard}>
          <span>Round Suggestion</span>
          <strong>{suggested ? "Advance" : "Hold"}</strong>
        </article>
        <article className={cls.statCard}>
          <span>Questions Left</span>
          <strong>{count}</strong>
        </article>
        <article className={cls.statCard}>
          <span>Turn Status</span>
          <strong>{turnStatus}</strong>
        </article>
      </div>

      <div className={cls.actionGrid}>
        <button
          type="button"
          className={cls.btn}
          disabled={loading || currentRound <= 1}
          onClick={() => onChangeRound?.(currentRound - 1)}
        >
          Prev Round
        </button>
        <button
          type="button"
          className={cls.btn}
          disabled={loading}
          onClick={() => onChangeRound?.(currentRound + 1)}
        >
          Next Round
        </button>
        <button
          type="button"
          className={cls.btn}
          disabled={loading || turnStatus !== "result_ready"}
          onClick={() => onOpenPenalty?.(turnView?.turn?._id)}
        >
          Open Penalty
        </button>
        <button
          type="button"
          className={cls.primaryBtn}
          disabled={loading || turnStatus !== "dare_active"}
          onClick={() => onResolveDare?.(turnView?.turn?._id)}
        >
          Resolve Dare
        </button>
      </div>
    </section>
  );
}
